// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Hooks$PrezzeeRibbon from "../../../abstracts/Hooks.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as VimeoPlayer__VideoContext$PrezzeeRibbon from "./VimeoPlayer__VideoContext.bs.js";

function VimeoPlayer__MobileAwareVideo(props) {
  var mobileBreakpoint = props.mobileBreakpoint;
  var mobileUrl = props.mobileUrl;
  var videoUrl = props.videoUrl;
  var mobileBreakpoint$1 = mobileBreakpoint !== undefined ? mobileBreakpoint : Theme__Responsive$PrezzeeRibbon.mobileBreakpoint;
  var windowSize = Hooks$PrezzeeRibbon.useWindowSize(250, undefined);
  var match = React.useState(function () {
        
      });
  var setCurrentVideo = match[1];
  var currentVideo = match[0];
  React.useEffect((function () {
          var isMobile = windowSize.width < mobileBreakpoint$1;
          if (windowSize.width !== 0) {
            if (currentVideo !== undefined) {
              if (isMobile && currentVideo !== mobileUrl) {
                Curry._1(setCurrentVideo, (function (param) {
                        return mobileUrl;
                      }));
              } else if (!isMobile && currentVideo !== videoUrl) {
                Curry._1(setCurrentVideo, (function (param) {
                        return videoUrl;
                      }));
              }
              
            } else {
              Curry._1(setCurrentVideo, (function (param) {
                      return isMobile ? mobileUrl : videoUrl;
                    }));
            }
          }
          
        }), [windowSize]);
  return JsxRuntime.jsx(VimeoPlayer__VideoContext$PrezzeeRibbon.Provider.make, {
              value: currentVideo,
              children: props.children
            });
}

var VideoContext;

var make = VimeoPlayer__MobileAwareVideo;

export {
  VideoContext ,
  make ,
}
/* react Not a pure module */
